import React from 'react'
import styled from 'styled-components'
import { ConditionalWrapper } from '../utils'
import AnimatedSection from './AnimatedSection'
import Container from './Container'
import ParallaxImage from './ParallaxImage'
import ResponsiveImage from './ResponsiveImage'

const StyledImageSection = styled.section``

const ParallaxImageSection = styled.section`

`

const ImageSection: React.FC<{
    data: object
}> = ({ data }) => {
    const { parallax, fullWidth } = data
    return (
        parallax ? (
            <ParallaxImageSection>
                <ParallaxImage>
                    <ResponsiveImage image={data} />
                </ParallaxImage>
            </ParallaxImageSection>
        ) : (
                <AnimatedSection>
                    <StyledImageSection>
                        <ConditionalWrapper condition={fullWidth == 'No'} wrapper={(children) => <Container>{children}</Container>}>
                            <ResponsiveImage image={data} />
                        </ConditionalWrapper>
                    </StyledImageSection>
                </AnimatedSection>
            )
    )
}

export default ImageSection
